var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitorLine = function SvgMonitorLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.75v10h-6.875v1.875H15v1.25H5v-1.25h4.375V13.75H2.5v-10h15ZM3.75 5v7.5h12.5V5H3.75Z"
  })));
};
export { SvgMonitorLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTcuNSAzLjc1VjEzLjc1SDEwLjYyNVYxNS42MjVIMTVWMTYuODc1SDVWMTUuNjI1SDkuMzc1VjEzLjc1SDIuNVYzLjc1SDE3LjVaTTMuNzUgNVYxMi41SDE2LjI1VjVIMy43NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";